import { RecurrenceCards } from "../RecurrenceCards";
import type { TChooseRecurrence } from "./types";

export const ChooseRecurrence = ({ allRecurrenceCards }: TChooseRecurrence) => {
  const ChooseRecurrenceElement = document.createElement("div");
  ChooseRecurrenceElement.className =
    "flex flex-wrap px-4 py-6 gap-4 justify-between items-center md:p-6";

  ChooseRecurrenceElement.innerHTML = /* html */ `
        <h4 class=" font-medium text-lg text-black-500 lg:text-xl">
            Selecione a recorrência
        </h4>
    `;

  ChooseRecurrenceElement.appendChild(
    RecurrenceCards({
      allRecurrenceCards,
      onClickChangeRecurrence: (recurrenceId) => console.log(recurrenceId),
    }),
  );

  return ChooseRecurrenceElement;
};
